import React, { useState, useEffect } from 'react'
import { FaMapMarkedAlt } from 'react-icons/fa'
import Image from 'next/image'
import { Button, Spinner, Chip } from "@heroui/react"

import { jsonGetFetcher } from '../src/fetchers'

export const getSignedUrl = (token, fileName, fileType, contentType, type='image') => {
  const signedUrl = `${process.env.API}/uploader/get-signed?fileName=${fileName}&fileType=${fileType}&contentType=${contentType}&type=${type}`
  return jsonGetFetcher([signedUrl, token])
}

export const uploadToS3 = async (signedRequest, fileType, file) => {
  // Upload file using Promise
  await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', signedRequest)
    xhr.setRequestHeader('Cache-Control', 'max-age=60')
    xhr.setRequestHeader('Content-Type', fileType)
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve()
        } else {
          reject(new Error('Upload failed'))
        }
      }
    }
    xhr.onerror = () => reject(new Error('XHR error'))
    xhr.send(file)
  })
}

const Upload = ({ token, label, onChange, existingUrl, uploadStart, externalError, btnText = 'Upload', type = 'image', element = 'button' }) => {
  const [uploading, setUploading] = useState(false)
  const [url, setUrl] = useState(existingUrl || '')
  const [error, setError] = useState('')
  const [displayFileName, setDisplayFileName] = useState('')

  useEffect(() => {
    setUrl(existingUrl)
    setError('')
  }, [existingUrl])

  useEffect(() => {
    if (externalError) {
      setUrl('')
      setUploading(false)
      setError(externalError)
    }
  }, [externalError])

  

  const onUploadChange = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    setUploading(true)
    if (uploadStart) uploadStart()
    const file = e.target.files[0]

    if (type !== 'map' && type !== 'fit' && (!file || !file.type)) {
      setError('Invalid file.')
      setUploading(false)
      return
    }

    let fileType = file.type.slice(file.type.lastIndexOf('/') + 1).toLowerCase()
    const fileParts = file.name.split('.')
    const contentType = fileParts[fileParts.length - 1].toLowerCase()
    
    if (type !== 'map' && type !== 'fit' && ['jpg', 'png', 'jpeg', 'gif'].indexOf(contentType) === -1) {
      setError('Invalid file type (jpg, png, or gif)')
      setUploading(false)
      return
    }

    if (type === 'map' && ['kml', 'gpx'].indexOf(contentType) === -1) {
      setError('Invalid file type. Must be KML or GPX file.')
      setUploading(false)
      return
    }

    if (type === 'fit' && ['fit'].indexOf(contentType) === -1) {
      setError('Invalid file type. Must be a FIT file.')
      setUploading(false)
      return
    }

    setDisplayFileName(file.name)
    const data = await getSignedUrl(token, file.name, type === 'map' ? 'kml' : fileType, contentType, type)

    await uploadToS3(data.signedRequest, type === 'map' ? 'kml' : fileType, file)
    if (type === 'map') setUploading(false)
    setUrl(data.url)
    onChange({
      key: data.key,
      url: data.url,
      fileType,
      contentType
    })
  }

  const remove = () => {
    setUploading(false)
    setUrl('')
    onChange('')
  }

  let fileUploadRef
  return <div>
    {element !== 'link' && <div className='text-xl flex items-center mb-2'>
      {label}
      {error && <Chip 
        className={'ml-2'}
        color='danger' 
        size='sm'
        onClose={setError('')}
      >
        {error}
      </Chip>}
    </div>}
    
    {(!uploading && !url) && <>
      {element === 'link' ? 
        <div className='text-center'>
          <a href='#' onClick={(e) => {e.preventDefault();setError('');fileUploadRef.click()}}>{label}</a>
        </div>
      : <Button
        color='secondary'
        onPress={() => { fileUploadRef.click() }}
        className='mb-4'
        type='button'>{btnText}</Button>
      }
    </>}

    {(!error && uploading) && <div className='text-center text-gray-400'>
      <Spinner color='primary' /><br/>
      Uploading
    </div>
    }

    {url && <div style={{ position: 'relative', width: (uploading ? '1px' : '100px'), minHeight: (uploading ? '1px' : '100px') }}>
      {type !== 'map' && type !== 'fit' && 
        <Image 
          src={url} 
          alt='upload' 
          width={0} height={0}
          sizes="(min-width: 768px) 300px, 300px"
          className='rounded-sm w-[100px] h-auto'

          onLoad={() => setUploading(false)} />}
      {type === 'map' && <><FaMapMarkedAlt style={{ fontSize: '60px', verticalAlign: 'middle', marginRight: '10px' }} /> {displayFileName}</>}
    </div>}
    {(url && !uploading) && <a onClick={remove} className='mb-8 inline cursor-pointer'>delete upload</a>}

    <input
      ref={input => { fileUploadRef = input }}
      type='file'
      onChange={onUploadChange} 
      className='hidden h-0 absolute'/>
  </div>
}

export default Upload
